<template>
<div class="chapter">
<div class="inner_page">
<section>
<h2><span class="h2-inner">Note on Coinage</span></h2>
<p class="firstInSection">Twelve pence make one shilling (1S.). Twenty shillings make one pound (1£).</p>
<p>There are also these coins: a farthing, four of which are worth one penny (1d.); a ha’penny, two of which are worth one penny; a crown, which is worth five shillings, and a half-crown (2S. 6d.); a sovereign, which is worth one pound; a guinea, which is worth twenty-one shillings (1£ 1s.).</p>
<p><em>Quid Quincunce speciosius, qui, in quamcunque partem</em> <em>spectaveris, rectus est? (Quintilian)</em></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter1.vue?0d384092